/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type FlagPrerequisitePost = {
  /**
   * Flag key of the prerequisite flag
   */
  key: string;
  /**
   * ID of a variation of the prerequisite flag
   */
  variationId: string;
};

/** @internal */
export const FlagPrerequisitePost$inboundSchema: z.ZodType<
  FlagPrerequisitePost,
  z.ZodTypeDef,
  unknown
> = z.object({
  key: z.string(),
  variationId: z.string(),
});
/** @internal */
export type FlagPrerequisitePost$Outbound = {
  key: string;
  variationId: string;
};

/** @internal */
export const FlagPrerequisitePost$outboundSchema: z.ZodType<
  FlagPrerequisitePost$Outbound,
  z.ZodTypeDef,
  FlagPrerequisitePost
> = z.object({
  key: z.string(),
  variationId: z.string(),
});

export function flagPrerequisitePostToJSON(
  flagPrerequisitePost: FlagPrerequisitePost,
): string {
  return JSON.stringify(
    FlagPrerequisitePost$outboundSchema.parse(flagPrerequisitePost),
  );
}
export function flagPrerequisitePostFromJSON(
  jsonString: string,
): SafeParseResult<FlagPrerequisitePost, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => FlagPrerequisitePost$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'FlagPrerequisitePost' from JSON`,
  );
}
